import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2005 24.1999C11.0686 24.2002 10.9381 24.1743 10.8163 24.1236C10.6946 24.073 10.5842 23.9987 10.4915 23.905L3.29128 16.6696C3.19868 16.5765 3.12534 16.4661 3.07542 16.3446C3.02551 16.2232 3.00001 16.0931 3.00037 15.9618C3.00073 15.8305 3.02696 15.7005 3.07754 15.5793C3.12813 15.4582 3.20209 15.3481 3.2952 15.2555C3.3883 15.1629 3.49874 15.0896 3.62019 15.0397C3.74164 14.9898 3.87174 14.9643 4.00305 14.9646C4.13436 14.965 4.26431 14.9912 4.38548 15.0418C4.50666 15.0924 4.61668 15.1664 4.70928 15.2595L11.2542 21.8366L27.3499 8.04169C27.5511 7.8692 27.8126 7.78371 28.0769 7.80404C28.3412 7.82437 28.5866 7.94885 28.759 8.15009C28.9315 8.35133 29.017 8.61286 28.9967 8.87713C28.9764 9.1414 28.8519 9.38678 28.6506 9.55927L11.8508 23.9587C11.67 24.1145 11.4392 24.2001 11.2005 24.1999Z",
		fill: "currentColor"
	})
});
export default SvgCheckBold;
